// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_5-3";
export var dialog = "_5-0";
export var divClassnameSwatch = "_5-8";
export var flexSwatch = "_5-4";
export var header = "_5-1";
export var styleAttributeSwatch = "_5-7";
export var swatch = "_5-2";
export var textHeaderSwatch = "_5-5";
export var webSwatch = "_5-6";